import { Button, styled } from '@teko/ui';
import { t } from 'i18n';

export interface HamperTabsProps {
  onClickTab?: (tab: number) => void;
  lsActiveTab?: number;
}
const Wrapper = styled.div`
  width: 100%;
  overflow-x: scroll;
  a {
    text-decoration: unset;
  }
`;

const StyledButton = styled(Button)`
  height: 40px;
  width: 30%;
  margin-right: 8px;
  margin-top: 8px;
`;

export const HamperTabs = ({
  onClickTab,
  lsActiveTab,
  ...props
}: HamperTabsProps) => {
  const {} = props;

  return (
    <Wrapper {...props}>
      {Array(5)
        .fill(null)
        .map((_, index: number) => (
          <StyledButton
            variant={index === lsActiveTab ? 'primary' : 'normal'}
            onClick={(): void => {
              onClickTab && onClickTab(index);
            }}
            key={`${index}`}
          >
            {t('Giỏ quà tự chọn')} {index + 1}
          </StyledButton>
        ))}
    </Wrapper>
  );
};
